export const version = '0.0.1';
